<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky">Паспортные данные</h1>
                <div class="form-wrap__row">
                    <c-input
                            :label="'Фамилия'"
                            :type="'text'"
                            :fieldName="'lastName'"
                            :validation="'alphaKaz'"
                            :externalStatus="lastNameExternalStatus"
                            v-model="lastName"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row">
                    <c-input
                            :label="'Имя'"
                            :type="'text'"
                            :fieldName="'firstName'"
                            :validation="'alphaKaz'"
                            :externalStatus="firstNameExternalStatus"
                            v-model="firstName"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row">
                    <c-input
                            :label="'Отчество'"
                            :type="'text'"
                            :fieldName="'secondName'"
                            :validation="'alphaKaz'"
                            :externalStatus="secondNameExternalStatus"
                            v-model="secondName"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip">
                            <c-tooltip-button v-if="secondName === ''" :clickEvent="noSecondName"
                                              :position="'left-bottom'" :top="60" :left="60"
                                              :text="'Нет отчества'"></c-tooltip-button>
                        </template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="nameBlockFilled && !isCompleteBlock('nameBlock')">
                    <div class="form-button__wrap">
                        <button class="form-button form-button--violet" v-on:click="save(['nameBlock'])">Продолжить
                        </button>
                    </div>
                </div>
                <div class="form-wrap__row" v-if="isCompleteBlock('nameBlock')">
                    <c-input-submit
                            :label="'ИИН'"
                            :type="'text'"
                            :fieldName="'iin'"
                            :validation="'decimal|min:12'"
                            :mask="'############'"
                            :externalStatus="iinExternalStatus"
                            v-model="iin"
                            :sendFunction="validateIIN"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input-submit>
                </div>
                <div class="form-wrap__row" v-if="completeIin">
                    <c-input
                            :label="'Дата рождения'"
                            :type="'tel'"
                            :fieldName="'birthDate'"
                            :mask="'##.##.####'"
                            :externalStatus="birthDateExternalStatus"
                            v-model="birthDate"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="completeIin">
                    <c-radio-group v-model="sex" :valueList="sexList" :label="sexLabel"
                                   :fieldName="'sex'"></c-radio-group>
                </div>

                <div class="form-wrap__row" v-if="iinBlockFilled && !isCompleteBlock('iinBlock')">
                    <div class="form-button__wrap">
                        <button class="form-button form-button--violet" v-on:click="save(['nameBlock', 'iinBlock'])">
                            Продолжить
                        </button>
                    </div>
                </div>

                <div class="form-wrap__row" v-if="isCompleteBlock('iinBlock')">
                    <c-radio-group v-model="document" :valueList="documentList" :label="'Документ'"
                                   :fieldName="'document'" v-on:change="selectDocumentType(document)"></c-radio-group>
                </div>
                <div class="form-wrap__row" v-if="document !== ''">
                    <c-radio-group v-model="citizenship" :valueList="citizenshipList" :label="'Гражданство'"
                                   :fieldName="'citizenship'"
                                   v-on:change="save(['nameBlock', 'iinBlock', 'documentTypeBlock', 'citizenshipBlock'])"></c-radio-group>
                </div>

                <div class="form-wrap__row" v-if="citizenship !== ''">
                    <c-input
                            :label="'Номер документа'"
                            :type="'tel'"
                            :fieldName="'documentNumber'"
                            :mask="'#########'"
                            :externalStatus="documentNumberExternalStatus"
                            v-model="documentNumber"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="citizenship !== ''">
                    <c-input
                            :label="'Дата выдачи'"
                            :type="'tel'"
                            :fieldName="'dateOfIssue'"
                            :mask="'##.##.####'"
                            :externalStatus="dateOfIssueExternalStatus"
                            v-model="dateOfIssue"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="citizenship !== ''">
                    <c-input
                            :label="'Срок действия'"
                            :type="'tel'"
                            :fieldName="'dateOfDuration'"
                            :mask="'##.##.####'"
                            :externalStatus="dateOfDurationExternalStatus"
                            v-model="dateOfDuration"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>


                <div class="form-wrap__row" v-if="documentBlockFilled && !isCompleteBlock('documentBlock')" >
                    <div class="form-button__wrap">
                        <button class="form-button form-button--violet"
                                v-on:click="save(['nameBlock', 'iinBlock','documentTypeBlock','citizenshipBlock','documentBlock'])">
                            Продолжить
                        </button>
                    </div>
                </div>

                <div class="form-wrap__row" v-if="isCompleteBlock('documentBlock')">
                    <p class="form-wrap__text-info">Проверьте правильность данных. Неверно введенные данные могут стать
                        причиной для отказа в микрокредите</p>
                    <div class="form-button__wrap">
                        <router-link :to="{name: 'Address'}"
                                     @click.native="save(['nameBlock', 'iinBlock','documentTypeBlock','citizenshipBlock','documentBlock'])"
                                     tag="button" class="form-button form-button--yellow form-button--long-text">Я
                            подтверждаю корректность данных
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import {createHelpers} from 'vuex-map-fields';
    import store from '@/storage/index'
    import {GET_PROFILE} from "@/storage/mutations";
    import {TOGGLE_LOADER, CHANGE_PROGRESS} from "@/storage/mutations";
    import {STATUSES} from "@/components/statuses";
    import Helper from '@/modules/Helpers';
    import registrationMixins from '@/modules/mixins/registrationMixins'



    const {mapFields} = createHelpers({
        getterType: 'profile/getField',
        mutationType: 'profile/updateField',
    });
    export default {
        mixins: [registrationMixins],
        name: 'PassportData',
        metaInfo: {
            title: 'Регистрация'
        },
        data() {
            return {
                sexList: [
                    {
                        label: 'Мужской',
                        value: 'MALE'
                    },
                    {
                        label: 'Женский',
                        value: 'FEMALE'
                    }
                ],
                documentList: [
                    {
                        label: 'Удостоверение личности РК',
                        value: 'IDENTITY_CARD'
                    },
                    {
                        label: 'Паспорт РК',
                        value: 'PASSPORT'
                    },
                ]
            };
        },
        watch: {
            iin: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                }
            },
            middleNameUpsent: function (newVal, oldVal) {
                if (newVal) {
                    this.secondName = 'Нет отчества'
                }
            },
            secondName: function (newVal, oldVal) {
                if (newVal !== '' && newVal !== 'Нет отчества') {
                    this.middleNameUpsent = false;
                }
            }
        },
        methods: {
            validateIIN: function () {
                let _this = this;
                let data = new URLSearchParams();
                data.append('iin', this.iin);
                this.iinExternalStatus = STATUSES.LOAD;
                this.$http.get('/json/profile/check_iin?iin=' + this.iin).then(
                    response => {
                        if (response.data.code === 0) {
                            setTimeout(_ => {
                                _this.iinExternalStatus = STATUSES.LOAD_END;
                                setTimeout(_ => {
                                    _this.birthDate = Helper.parseDateFromIin(this.iin).formatDate;
                                    _this.birthDateExternalStatus = STATUSES.COMPLETE;
                                    _this.iinExternalStatus = STATUSES.COMPLETE;
                                }, 1000);
                            }, 6000);
                        } else if (response.data.code === 200) {
                            _this.$validator.errors.add(
                                'iin',
                                'Неккоректный ИИН'
                            );
                            _this.iinExternalStatus = STATUSES.LOAD_ERROR;
                        }
                    },
                    response => {
                        console.log(response);
                    }
                );
            },
            noSecondName: function () {
                this.secondName = 'Нет отчества';
                this.middleNameUpsent = true;
            },
            selectDocumentType(value) {
                if (value !== 'RESIDENCE_PERMIT') {
                    this.citizenship = 'Казахстан';
                    this.citizenshipExternalStatus = STATUSES.APPROVE;
                    this.save(['nameBlock', 'iinBlock', 'documentTypeBlock', 'citizenshipBlock']);
                } else {
                    this.save(['nameBlock', 'iinBlock', 'documentTypeBlock']);
                    this.citizenship = '';
                }
            }
        },
        computed: {
            completeIin: function () {
                return this.iinExternalStatus === STATUSES.COMPLETE;
            },
            sexLabel: function () {
                return this.sexExternalStatus === STATUSES.COMPLETE ? 'Пол' : 'Выберите ваш пол';
            },
            nameBlockFilled: function () {
                return this.lastName !== '' && this.firstName !== '' && this.secondName !== '';
            },
            iinBlockFilled: function () {
                return this.iin !== '' && this.birthDate !== '' && this.sex !== '';
            },
            documentBlockFilled: function () {
                return this.documentNumber.length === 9 && this.dateOfIssue.length === 10 && this.dateOfDuration.length === 10;
            },
            citizenshipList: function () {
                if (this.document !== 'RESIDENCE_PERMIT') {
                    return [
                        {
                            label: 'Казахстан',
                            value: 'Казахстан'
                        }
                    ]
                } else {
                    return [
                        {
                            label: 'Россия',
                            value: 'Россия'
                        },
                        {
                            label: 'Киргизия',
                            value: 'Киргизия'
                        }
                    ]
                }
            }
            ,
            ...mapFields([
                    'lastName',
                    'lastNameExternalStatus',
                    'firstName',
                    'firstNameExternalStatus',
                    'middleNameUpsent',
                    'secondName',
                    'secondNameExternalStatus',
                    'iin',
                    'iinExternalStatus',
                    'birthDate',
                    'birthDateExternalStatus',
                    'sex',
                    'sexExternalStatus',
                    'document',
                    'documentExternalStatus',
                    'citizenship',
                    'citizenshipExternalStatus',
                    'documentNumber',
                    'documentNumberExternalStatus',
                    'dateOfIssue',
                    'dateOfIssueExternalStatus',
                    'dateOfDuration',
                    'dateOfDurationExternalStatus'
                ]),
        },
        mounted() {
            this.$store.commit("CHANGE_PROGRESS", {
                progressBarShow: true,
                currentPercent: 10,
                nextPercent: 20
            });
        }
    }
</script>

<style lang="scss">
</style>
